var _rect, _rect2, _rect3, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQCafList = function SvgQCafList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 2,
    x: 8,
    y: 5,
    fill: "#503CC8",
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 2,
    x: 8,
    y: 11,
    fill: "#503CC8",
    rx: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 2,
    x: 8,
    y: 17,
    fill: "#503CC8",
    rx: 1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 6,
    r: 1.5,
    fill: "#503CC8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 12,
    r: 1.5,
    fill: "#503CC8"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 18,
    r: 1.5,
    fill: "#503CC8"
  })));
};
export { SvgQCafList as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iOCIgeT0iNSIgd2lkdGg9IjEyIiBoZWlnaHQ9IjIiIHJ4PSIxIiBmaWxsPSIjNTAzQ0M4Ii8+CjxyZWN0IHg9IjgiIHk9IjExIiB3aWR0aD0iMTIiIGhlaWdodD0iMiIgcng9IjEiIGZpbGw9IiM1MDNDQzgiLz4KPHJlY3QgeD0iOCIgeT0iMTciIHdpZHRoPSIxMiIgaGVpZ2h0PSIyIiByeD0iMSIgZmlsbD0iIzUwM0NDOCIvPgo8Y2lyY2xlIGN4PSI1LjUiIGN5PSI2IiByPSIxLjUiIGZpbGw9IiM1MDNDQzgiLz4KPGNpcmNsZSBjeD0iNS41IiBjeT0iMTIiIHI9IjEuNSIgZmlsbD0iIzUwM0NDOCIvPgo8Y2lyY2xlIGN4PSI1LjUiIGN5PSIxOCIgcj0iMS41IiBmaWxsPSIjNTAzQ0M4Ii8+Cjwvc3ZnPgo=";